import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import { CssBaseline } from "@mui/material";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";

import "appConfig";

import { ErrorHandler } from "components/ErrorHandler";
import { GlobalLayout } from "components/GlobalLayout";
import { Timeout } from "components/utility/Timeout";

import { setAuthenticationState } from "services/utility/authentication";
import { addChurnZero } from "services/utility/churnZero";
import { isBetaEnvironment } from "services/utility/misc";

import { useChurnZero } from "hooks/useChurnZero";

import { theme } from "SosTheme";
import { globalPrintStyles } from "globalStyles";

export default function App() {
  useEffect(() => {
    async function _setAuthenticationState() {
      await setAuthenticationState();
    }
    _setAuthenticationState();
  }, []);

  useEffect(() => {
    // add ChurnZero window script for beta environment
    isBetaEnvironment && addChurnZero();
  }, []);

  // Initialize ChurnZero tracking when user logs in
  useChurnZero();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {globalPrintStyles}
        <CssBaseline />
        <BrowserRouter>
          <ErrorHandler>
            <GlobalLayout />
            <Timeout />
          </ErrorHandler>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
